import { Loader } from "./Loader";
import { Scene } from "./Scene";
import { mat4 } from "gl-matrix";
import { Controller } from "./Controller";
import { AnimationFrame } from "../Animation/AnimationFrame";
import { Animation } from "../Animation/Animation";
import { Geometry } from './Geometry';
import { Material } from './Material';

export class SceneNode {
    public id: string;
    public sid: string;
    public name: string;

    public type: string;
    public subType: string;

    public visualScene: Scene;
    public parentNode: SceneNode;
    public childNodes: SceneNode[];
    public animationFrames: { [key: string]: AnimationFrame[] };
    public animated: boolean;

    public controller: Controller;
    public skeletonNodes: SceneNode[];

    public geometry: Geometry;
    public material: Material;

    public jointMatrix: mat4;

    public animation: Animation;

    private transforms: mat4[];

    constructor() {
        this.animationFrames = {};
    }

    public loadBlob(dataView: DataView, loader: Loader) {
        let offset = 0;

        let typeResult = loader.util.readString(dataView, offset);
        this.type = typeResult.string;
        offset = typeResult.offset;

        let subTypeResult = loader.util.readString(dataView, offset);
        this.subType = subTypeResult.string;
        offset = subTypeResult.offset;

        let sidResult = loader.util.readString(dataView, offset);
        this.sid = sidResult.string;
        offset = sidResult.offset;

        let idResult = loader.util.readString(dataView, offset);
        this.id = idResult.string;
        offset = idResult.offset;

        let nameResult = loader.util.readString(dataView, offset);
        this.name = nameResult.string;
        offset = nameResult.offset;

        let transforms = new Array<mat4>();
        let transformCount = dataView.getInt32(offset, true);
        offset += 4;

        let matrix = mat4.create();// mat4.identity(mat4.create());

        // TODO: Test these transformations, animation works fine with just a single
        // matrix transform, but combinations with other transforms has not been tested.
        for (let i = 0; i < transformCount; i++) {
            let transformResult = loader.util.readString(dataView, offset);
            let transformType = transformResult.string;
            offset = transformResult.offset;

            let floatResult = loader.util.readFloatList(dataView, offset);
            let floats = floatResult.floats;
            offset = floatResult.offset;

            switch (transformType) {
                case 'matrix':
                    transforms.push(floatResult.mat4());
                    matrix = floatResult.mat4(); // or matrix = matrix * floats?
                    break;
                //case 'rotate':
                //    matrix = mat4.rotate(matrix, matrix, glMatrix.toRadian(floats[3]), floats);
                //    break;
                //case 'translate':
                //    matrix = mat4.translate(matrix, matrix, floats);
                //    break;
                //case 'scale':
                //    matrix = mat4.scale(matrix, matrix, floats);
                //    break;
                //default:
                //    console.warn(`Unknown transform type ${transformType}`, floats);
                //    break;
            }
        }

        this.jointMatrix = matrix;
        this.transforms = transforms;

        let childListResult = loader.util.readIdentityList<SceneNode>(dataView, offset);
        this.childNodes = childListResult.items;
        offset = childListResult.offset;

        this.childNodes.forEach(node => node.parentNode = this);

        if (this.subType === 'controller') {
            let controllerReference = dataView.getInt32(offset, true);
            offset += 4;

            this.controller = loader.getBlob<Controller>(controllerReference);

            let skeletonListResult = loader.util.readIdentityList<SceneNode>(dataView, offset);
            this.skeletonNodes = skeletonListResult.items;
            offset = skeletonListResult.offset;
        } else if (this.subType === 'geometry') {
            let geoReference = dataView.getInt32(offset, true);
            offset += 4;

            this.geometry = loader.getBlob<Geometry>(geoReference);

            let materialReference = dataView.getInt32(offset, true);
            offset += 4;

            this.material = loader.getBlob<Material>(materialReference);
        }
    }

    public getJointTransform(): mat4 {
        let ms: mat4[] = [this.jointMatrix];
        let node: SceneNode = this;
        while (node != null) {
            ms.push(node.jointMatrix);
            node = node.parentNode;
        }

        let m = mat4.create();
        for (let matrix of ms) {
            mat4.multiply(m, m, matrix);
        }

        return m;
    }


    public isDescendantOf(sid: string): boolean {
        let node: SceneNode = this;
        while (node !== null) {
            if (node.sid === sid) {
                return true;
            } else {
                node = node.parentNode;
            }
        }

        return false;
    }

    public getAnimationFrames(state) {
        return this.animationFrames[state];
    }
}
